import { render, staticRenderFns } from "./Report-2.vue?vue&type=template&id=13f6b8bc&scoped=true"
import script from "./Report-2.vue?vue&type=script&lang=js"
export * from "./Report-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f6b8bc",
  null
  
)

export default component.exports